import React from 'react';
import Overview from "./Overview";
import {CampaignContext} from "../../App";

const Dashboard = (props) => {

    const {selectedCampaign} = React.useContext(CampaignContext);

    return selectedCampaign ?
            <div className="p-grid card">
                <div className="p-col-12">
                    <Overview />
                </div>
            </div> : <></>;
};
export default Dashboard;
